import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["role"]
const _hoisted_2 = { class: "lead" }
const _hoisted_3 = { key: 0 }


import { Alert, AlertStatus } from '@/composables/alert';


export default /*#__PURE__*/_defineComponent({
  props: {
    alert: null
  },
  setup(__props: any) {



const defaultMessage: Record<AlertStatus, string> = {
    success: 'Succès',
    error: 'Une erreur est survenue',
    conflict: 'Cette opération ne peut être effectuée'
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: __props.alert.status === 'success' ? 'status' : 'alert',
    class: "text-center"
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["h1 d-block text-center text-success", {
            'text-success': __props.alert.status === 'success',
            'text-danger' : __props.alert.status === 'error',
            'text-dark' : __props.alert.status === 'conflict'
        }])
    }, [
      _createElementVNode("i", {
        class: _normalizeClass({
                'far fa-check-circle': __props.alert.status === 'success',
                'far fa-times-circle' : __props.alert.status === 'error',
                'fas fa-ban' : __props.alert.status === 'conflict'
                })
      }, null, 2)
    ], 2),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.alert.summary || defaultMessage[__props.alert.status]), 1),
    (__props.alert.detail)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.alert.detail), 1))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})